/**
 * moonService — Phase lunaire calculée localement (sans API)
 * Algorithme basé sur le jour julien — précision ±1 jour
 */

/** Durée d'un cycle lunaire en jours */
const LUNAR_CYCLE = 29.53058867;

/**
 * Calcule la phase lunaire pour une date donnée.
 * @param {Date} date
 * @returns {{ phase: string, icon: string, age: number, illumination: number, nextFullMoon: Date }}
 */
export function getMoonPhase(date = new Date()) {
  const year  = date.getFullYear();
  const month = date.getMonth() + 1;
  const day   = date.getDate();

  // Calcul du jour julien
  const jd = 367 * year
    - Math.floor(7 * (year + Math.floor((month + 9) / 12)) / 4)
    + Math.floor(275 * month / 9)
    + day + 1721013.5;

  // Âge de la lune (jours depuis la dernière nouvelle lune)
  const moonAge = ((jd - 2451550.1) % LUNAR_CYCLE + LUNAR_CYCLE) % LUNAR_CYCLE;

  // Pourcentage d'illumination (0 = nouvelle lune, 100 = pleine lune)
  const illumination = Math.round(
    (1 - Math.cos((moonAge / LUNAR_CYCLE) * 2 * Math.PI)) / 2 * 100
  );

  // Phase texte + icône
  let phase, icon;
  if      (moonAge < 1.85)  { phase = 'Nouvelle lune';                icon = '🌑'; }
  else if (moonAge < 7.38)  { phase = 'Premier croissant';            icon = '🌒'; }
  else if (moonAge < 9.22)  { phase = 'Premier quartier';             icon = '🌓'; }
  else if (moonAge < 14.77) { phase = 'Lune gibbeuse croissante';     icon = '🌔'; }
  else if (moonAge < 16.61) { phase = 'Pleine lune';                  icon = '🌕'; }
  else if (moonAge < 22.15) { phase = 'Lune gibbeuse décroissante';   icon = '🌖'; }
  else if (moonAge < 23.99) { phase = 'Dernier quartier';             icon = '🌗'; }
  else                      { phase = 'Dernier croissant';            icon = '🌘'; }

  // Jours avant la prochaine pleine lune
  const daysToFullMoon = moonAge <= 14.77
    ? Math.round(14.77 - moonAge)
    : Math.round(LUNAR_CYCLE - moonAge + 14.77);

  const nextFullMoon = new Date(date);
  nextFullMoon.setDate(nextFullMoon.getDate() + daysToFullMoon);

  return {
    phase,
    icon,
    age: Math.round(moonAge),
    illumination,
    daysToFullMoon,
    nextFullMoon,
    isFullMoon: moonAge >= 14.77 && moonAge < 16.61,
    isNewMoon: moonAge < 1.85 || moonAge >= 29.0,
  };
}

export default getMoonPhase;
